{
  "INTERNAL_ERROR": "Ocurrió un error inesperado. Inténtalo de nuevo.",
  "BAD_REQUEST": "No se pudo procesar la solicitud.",
  "UNAUTHORIZED": "Tu sesión no es válida. Inicia sesión de nuevo.",
  "FORBIDDEN": "No tienes permiso para realizar esta acción.",
  "NOT_FOUND": "No se encontró lo que buscas.",
  "CONFLICT": "Esta acción entra en conflicto con datos existentes.",
  "TOO_MANY_REQUESTS": "Demasiados intentos. Espera un momento y vuelve a intentarlo.",
  "SERVICE_UNAVAILABLE": "El servicio no está disponible en este momento.",
  "VALIDATION_FAILED": "Revisa los datos enviados.",
  "VALIDATION_INVALID_FIELD": "El campo \"{{field}}\" no es válido.",
  "RECORD_ALREADY_EXISTS": "Ya existe un registro con estos datos ({{fields}}).",
  "RECORD_NOT_FOUND": "Registro no encontrado.",
  "RELATED_RECORD_NOT_FOUND": "No se encontró el registro relacionado.",
  "RELATION_VIOLATION": "Esta acción rompería la relación entre registros.",
  "DATABASE_ERROR": "Error al acceder a los datos. Inténtalo de nuevo.",
  "DATABASE_VALIDATION_ERROR": "Los datos enviados no son válidos.",
  "TENANT_NOT_IDENTIFIED": "Área de miembros no identificada. Verifica la dirección de acceso."
}
